import { createSelector } from 'reselect'
import { StoreState } from 'store/state'
import { initialState } from './state'

export const snackbarSelector = (state: StoreState) => state.snackbar || initialState()
export const pendingSnackbarSelector = createSelector(snackbarSelector, (snackbar) => snackbar.pending)
export const peekSnackbarSelector = createSelector(pendingSnackbarSelector, (pending) => pending[0] || undefined)
export const tailSnackbarSelector = createSelector(pendingSnackbarSelector, (pending) => pending.slice(1))
